import http from "@/utils/http";
import qs from "qs";
import { stringToHash } from "@/utils/utils";

/**
 * 登录接口
 * @param {*} {
    "country_code": "string",
    "phone": "string",
    "phone_verify_code": "string",
    "invitation_code": "string"
  } 
 */
export function loginRegisterShare(params, callback) {
	http
		.post("/api/users/login_register_share", params, {
			headers: {
				"device-identifier": stringToHash(navigator.userAgent.replace(/[^\w]/gi, "")),
				"app-platform": "web",
			},
		})
		.then(function (response) {
			// 处理成功情况
			callback(null, response);
		})
		.catch(function (error) {
			// 处理错误情况
			console.log(error);
			callback(null, error);
		})
		.finally(function () {
			// 总是会执行
		});
}

/**
 * 获取验证码
 * @param {*} country_code
 * @param {*} phone
 * @param {*} callback
 */
export function sendPhoneVerificationCode(params) {
	return new Promise((resolve, reject) => {
		http
			.post(`/api/users/send_phone_verification_code_captcha`, params)
			.then(function (response) {
				// 处理成功情况
				resolve(response);
			})
			.catch(function (error) {
				// 处理错误情况
				reject(error);
			});
	});
}

/**
 * 创建邀请码
 */
export function createInvitationCode() {
	return new Promise((resolve, reject) => {
		http
			.post("/api/users/create_invitation", null, {
				headers: {
					Authorization: "Bearer 666",
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export function refreshToken(headers) {
	return new Promise((resolve, reject) => {
		http
			.post("/api/users/refresh_token", null, {
				headers: headers,
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export function getDownloadUrl(params) {
	return new Promise((resolve, reject) => {
		http
			.get(`/api/invitation/get_download_url?${qs.stringify(params)}`)
			.then(res => {
				resolve(res.payload.download_url);
			})
			.catch(err => {
				reject(err);
			});
	});
}
